<div class="container card custom-width p-3 mt-3" *ngIf="data">
  <h2 class="mb-3 text-primary text-center">
    Education Daily Work Update
  </h2>

  <!-- SCROLLABLE AREA -->
  <div class="table-scroll">
    <table class="table table-bordered mb-0">
      <tbody>

      <tr>
        <th>Centre</th>
        <td>
          <ng-container *ngFor="let c of data.centre; let i = index">
            {{ c.centreName }}
            <span *ngIf="i < data.centre.length - 1">, </span>
          </ng-container>
        </td>
      </tr>

      <tr>
        <th>Date</th>
        <td>{{ data?.date?.toDate() | date:'dd MMM yyyy' }}</td>
      </tr>

      <tr>
        <th>Teacher Type</th>
        <td>{{ data?.teacherType }}</td>
      </tr>

      <tr>
        <th>Submitted By</th>
        <td>{{ data?.submittedBy }}</td>
      </tr>

      <tr>
        <th>Task / Activities</th>
        <td class="pre-line-text">
          {{ data?.task }}
        </td>
      </tr>

      <tr>
        <th>Remarks</th>
        <td class="pre-line-text">
          {{ data?.remarks }}
        </td>
      </tr>

      </tbody>
    </table>
  </div>

  <div class="row justify-content-center d-flex mt-3">
    <div class="col-md-4 text-center">
      <button mat-raised-button color="primary" (click)="onClose()">
        Close
      </button>
    </div>
  </div>
</div>
